import React from 'react'
import { useOrganization } from 'src/graphql/hooks'
import LayoutHorizontal from 'src/apps/Global/components/Nav/LayoutHorizontal'
import LayoutVertical from 'src/apps/Global/components/Nav/LayoutVertical'

// Custom GlobalNavs
import FuseGlobalNav from 'src/custom/fuse/GlobalNav'
import GNS3GlobalNav from 'src/custom/gns3/GlobalNav'

const customGlobalNavs = {
   fuse: FuseGlobalNav,
   gns3: GNS3GlobalNav,
   'mother-co': LayoutVertical
}

// =======================================================
// Component
// =======================================================

const GlobalNav = () => {
   const { organization } = useOrganization()

   if (organization.hasCustomGlobalNav) {
      const CustomGlobalNav = customGlobalNavs[organization.slug]
      return <CustomGlobalNav />
   }

   return (
      <LayoutHorizontal />
   )
}

export default GlobalNav
